import React, { useState } from 'react';
import Text from 'components/Text/Text';
import breadcrumbs from 'images/breadcrumbs.svg';
import classNames from 'classnames';
import style from './ViewPageBlock.module.scss';

interface IProps {
	heading: string;
	children: React.ReactNode;
}

export const ViewPageBlock: React.FC<IProps> = ({ heading, children }) => {
	const [isVisibleContent, setIsVisibleContent] = useState(true);
	const childrenWrapperClasses = classNames(style.childrenWrapper, { [style.hide]: !isVisibleContent });
	const closeIconClasses = classNames(style.icon, {
		[style.rotate]: !isVisibleContent,
	});

	return (
		<div className={style.container} data-test="ViewPageBlock">
			<div className={style.header}>
				<Text translationNameSpace="form" translationKey={heading} theme="secondary" size="l" weight="bold" />
				<div className={style.btn} onClick={() => setIsVisibleContent(!isVisibleContent)}>
					<svg className={closeIconClasses}>
						<use xlinkHref={`${breadcrumbs}#closeInfo`} />
					</svg>
				</div>
			</div>
			<div className={childrenWrapperClasses}>{children}</div>
		</div>
	);
};
